module.exports = __webpack_public_path__ + "static/media/facebook.7f6f3b44.svg";